import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
// noinspection ES6CheckImport
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import InputMask from 'react-input-mask';

import CurrencyInput from 'react-currency-input';
import ReactLoading from 'react-loading';
import firebase from '../../../config/firebase';

import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';

import { uploadFileImage } from '../../../database/utils/storage';

import * as S from './styles';
import ImgUploadBtn from '../../molecules/ImgUploadBtn';
import {
  getProduct,
  updateProduct,
  parseData
} from '../../../database/repositories/ProductRepository';

import { moneyBRToFloat } from '../../../utils/util';

// noinspection DuplicatedCode
function CadProdView() {
  const history = useHistory();

  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [brand, setBrand] = useState('');
  const [price, setPrice] = useState('');
  const [department, setDepartment] = useState('informatica');
  const [condition, setCondition] = useState('novo');
  const [subcategory, setSubcategory] = useState('');
  const [height, setHeight] = useState('');
  const [width, setWidth] = useState('');
  const [length, setLength] = useState('');
  const [weight, setWeight] = useState('');
  const [quantity, setQuantity] = useState('');
  const [delivery, setDelivery] = useState('pac');

  const [productId, setProductId] = useState('');
  const [img1, setImg1] = useState(null);
  const [img2, setImg2] = useState(null);
  const [img3, setImg3] = useState(null);
  const [img4, setImg4] = useState(null);
  const [img5, setImg5] = useState(null);

  const [msgType, setMsgType] = useState();
  const [msg, setMsg] = useState();
  const [loading, setLoading] = useState(false);

  const db = firebase.firestore();
  const userID = useSelector((state) => state.auth.uid);

  useEffect(() => {
    const productID = query.get('productID');

    if (!productID) return;

    getProduct(productID).then((product) => {
      if (!product || product.seller !== userID) {
        return;
      }

      setProductId(product.id);
      setName(product.name);
      setDescription(product.description);
      setBrand(product.brand);
      setPrice(product.price);
      setDepartment(product.department);
      setSubcategory(product.subcategory);
      setCondition(product.condition);
      setHeight(product.dimensions[0]);
      setWidth(product.dimensions[1]);
      setLength(product.dimensions[2]);
      setWeight(product.weight);
      setQuantity(product.quantity);
      setDelivery(product.delivery);

      setImg1(product.pictures[0]);
      setImg2(product.pictures[1]);
      setImg3(product.pictures[2]);
      setImg4(product.pictures[3]);
      setImg5(product.pictures[4]);
    });
  }, [query, userID]);

  const uploadImgs = async (productID) => {
    const images = [img1, img2, img3, img4, img5];

    const isNewImage = (img) => Array.isArray(img);
    const promisedImages = images
      .filter((img) => img)
      .map(async (img, index) => {
        if (isNewImage(img)) {
          const task = await uploadFileImage(`produtos/${productID}/${index}`, img[1]);
          const image = await task.ref.getDownloadURL();
          return image;
        }

        return img;
      }, []);

    return Promise.all(promisedImages);
  };

  const handleUpdateProduct = async () => {
    const images = await uploadImgs(productId);

    await updateProduct(productId, {
      name,
      description,
      brand,
      price,
      department,
      subcategory,
      condition,
      dimensions: [height, width, length],
      weight,
      quantity,
      delivery,
      pictures: images
    });
    setLoading(false);
    return history.push('/usuario/vitrine');
  };

  async function cadProduct() {
    setLoading(true);
    if (
      !name ||
      !description ||
      !brand ||
      !price ||
      !department ||
      !condition ||
      !height ||
      !width ||
      !length ||
      !weight ||
      !quantity ||
      !delivery
    ) {
      setMsgType('error');
      setMsg('Preencha todos os campos para cadastrar o produto.');
      setTimeout(() => {
        setLoading(false);
      }, 250);
      return false;
    }
    if (!(img1 || img2 || img3 || img4 || img5)) {
      setMsgType('error');
      setMsg('Envie ao menos uma imagem do kacareco.');

      setTimeout(() => {
        setLoading(false);
      }, 250);
      return false;
    }

    if (productId) return handleUpdateProduct();

    const time = new Date();
    const res = await db
      .collection('produtos')
      .add(
        parseData({
          seller: userID,
          name,
          description,
          brand,
          price,
          department,
          subcategory,
          condition,
          dimensions: [height, width, length],
          weight,
          quantity,
          delivery,
          pictures: [],
          addedDate: time.getTime(),
          deleted: false
        })
      )
      .catch((error) => {
        setMsgType('error');
        setMsg('Erro ao salvar produto, tente novamente mais tarde.');
        console.error(error.message);
      });

    setProductId(res.id);

    const imgUrls = await uploadImgs(res.id);

    await db
      .collection('produtos')
      .doc(res.id)
      .get()
      .then((result) => {
        setMsgType('success');
        setMsg('Kacareco cadastrado com sucesso!');
        const data = result.data();
        data.pictures = imgUrls;
        db.collection('produtos').doc(res.id).set(data);
      })
      .catch((error) => console.error(error.message));

    setLoading(false);
    setTimeout(() => {
      document.location.reload(true);
    }, 250);
  }

  return (
    <S.Container>
      {useSelector((state) => state.auth.user_logged_in) < 1 ? <Redirect to="/entrar" /> : null}
      <Header />
      <NavBar />
      <MainContent>
        <div className="signup-content">
          <div className="signup-top-section">
            <form>
              <div className="signup-top-section-left">
                <h3>Foto</h3>
                <ImgUploadBtn
                  className="signup-photo-circle"
                  id="img_prod_1"
                  src={img1}
                  onChange={setImg1}
                  flavorTxt="CLIQUE PARA ADICIONAR FOTOS"
                />
                <div className="container">
                  <div className="row">
                    <ImgUploadBtn
                      className="circle"
                      id="img_prod_2"
                      src={img2}
                      onChange={setImg2}
                      style={{ padding: 0 }}
                    />
                    <ImgUploadBtn
                      className="circle"
                      id="img_prod_3"
                      src={img3}
                      onChange={setImg3}
                      style={{ padding: 0 }}
                    />
                    <div className="w-100" />
                    <ImgUploadBtn
                      className="circle"
                      id="img_prod_4"
                      src={img4}
                      onChange={setImg4}
                      style={{ padding: 0 }}
                    />
                    <ImgUploadBtn
                      className="circle"
                      id="img_prod_5"
                      src={img5}
                      onChange={setImg5}
                      style={{ padding: 0 }}
                    />
                  </div>
                </div>
              </div>
              <div className="signup-top-section-right">
                <ul>
                  <li>
                    <h3>Nome</h3>
                    <input
                      type="text"
                      placeholder="Nome do produto"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </li>
                  <li>
                    <h3>Descriçao</h3>
                    <textarea
                      onChange={(e) => setDescription(e.target.value)}
                      value={description}
                      placeholder="Ex: Furadeira laranja nova com cabo emborrachado, usada poucas vezes."
                    />
                  </li>
                  <li className="signup-form-row">
                    <div style={{ marginRight: '15px' }}>
                      <h3>Marca</h3>
                      <input
                        type="text"
                        placeholder="Marca do produto?"
                        value={brand}
                        onChange={(e) => setBrand(e.target.value)}
                      />
                    </div>

                    <div style={{ marginLeft: '15px' }}>
                      <h3>Preço</h3>
                      <CurrencyInput
                        prefix="R$ "
                        decimalSeparator=","
                        thousandSeparator="."
                        placeholder="R$"
                        value={price}
                        onChangeEvent={(event) => setPrice(moneyBRToFloat(event.target.value))}
                      />
                    </div>
                  </li>
                  <div
                    style={{
                      backgroundColor: '#e7e6e6',
                      height: 3,
                      width: '100%',
                      margin: '30px 0'
                    }}
                  />
                  <li className="signup-form-row">
                    <div style={{ marginRight: '15px' }}>
                      <h3>Departamento</h3>
                      <select
                        value={department}
                        onChange={(event) => setDepartment(event.target.value)}>
                        <option value="informatica">Informática</option>
                        <option value="decoracao">Decoração</option>
                        <option value="brinquedos">Brinquedos</option>
                        <option value="bebes">Bebês</option>
                        <option value="ferramentas">Ferramentas</option>
                        <option value="moda">Moda</option>
                        <option value="pet">Pet</option>
                        <option value="Beleza">Beleza</option>
                        <option value="fitness">Fitness</option>
                        <option value="games">Games</option>
                      </select>
                    </div>
                    <div style={{ marginLeft: '15px' }}>
                      <h3>Condição</h3>
                      <select
                        value={condition}
                        onChange={(event) => setCondition(event.target.value)}>
                        <option value="novo">Novo</option>
                        <option value="seminovo">Seminovo</option>
                        <option value="usado">Usado</option>
                      </select>
                    </div>
                  </li>
                  <li className="signup-form-row">
                    <div style={{ marginRight: '15px' }}>
                      <h3>Subcategoria</h3>
                      <input
                        type="text"
                        value={subcategory}
                        onChange={(event) => setSubcategory(event.target.value)}
                        placeholder="Subtipo"
                      />
                    </div>
                    <div style={{ marginLeft: '15px' }}>
                      <h3>
                        Dimensões <span style={{ fontSize: 12 }}>(Altura Largura Comprimento)</span>
                      </h3>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          width: '100%'
                        }}>
                        <InputMask
                          value={height}
                          onChange={(e) => setHeight(e.target.value)}
                          mask="99999999"
                          placeholder="cm"
                          maskChar=" "
                        />
                        <InputMask
                          value={width}
                          onChange={(e) => setWidth(e.target.value)}
                          mask="99999999"
                          style={{ marginLeft: 15, marginRight: 15 }}
                          placeholder="cm"
                          maskChar=" "
                        />
                        <InputMask
                          value={length}
                          onChange={(e) => setLength(e.target.value)}
                          mask="99999999"
                          placeholder="cm"
                          maskChar=" "
                        />
                      </div>
                    </div>
                  </li>
                  <li className="signup-form-row">
                    <div style={{ marginRight: '15px', display: 'flex', flexDirection: 'row' }}>
                      <div>
                        <h3>Peso</h3>
                        <input
                          type="number"
                          value={weight}
                          onChange={(event) => setWeight(event.target.value)}
                          placeholder="Em kilogramas"
                        />
                      </div>
                      <div style={{ marginLeft: 15 }}>
                        <h3>Quantidade</h3>
                        <InputMask
                          value={quantity}
                          onChange={(e) => setQuantity(e.target.value)}
                          mask="99999999"
                          placeholder="Unidades"
                          maskChar=" "
                        />
                      </div>
                    </div>
                    <div className="signup-top-section-left" style={{ marginLeft: '15px' }}>
                      <h3>Frete</h3>
                      <select
                        value={delivery}
                        onChange={(event) => setDelivery(event.target.value)}>
                        <option value="pac">PAC Correios</option>
                        <option value="sedex">Sedex</option>
                      </select>
                    </div>
                  </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
        <div
          style={{
            backgroundColor: '#e7e6e6',
            height: 3,
            width: '100%'
          }}
        />
      </MainContent>
      <div className="signup-bot-section">
        {loading ? (
          <ReactLoading type="spinningBubbles" color="#002666" height={60} width={60} />
        ) : (
            <button onClick={() => cadProduct()} type="button">
              {productId ? 'Atualizar Produto' : 'Enviar Produto'}
            </button>
          )}
        {msgType != null && <p style={{ color: '#002666' }}>{msg}</p>}
      </div>
      <Footer />
    </S.Container>
  );
}

export default CadProdView;
